/** @format */
// 创建、修改事件告警Drawer
import React, { FC, useState, useRef, useMemo } from 'react'
import {
  _$,
  Card,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Message,
  Radio,
  Button,
  Switch
} from '@king-design/react'
import { useHistory, useParams } from 'react-router'
import { useAsync } from 'react-use'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import SelectTemplate from 'src/containers/MonitorAlarmTemplate/SelectTemplate'
import { eventListToOptions } from 'src/pages/EventCenter/constants'
import SelectEventRule from 'src/components/SelectEventRule'
import AlarmReciver from 'src/components/AlarmReciver'
import AlarmCallBack from 'src/components/AlarmCallBack'
import AlarmCallBackTooltip from 'src/components/AlarmCallBack/Tooltip'
import ApiEventCenter from 'src/api/ApiEventCenter'
import { API } from 'src/api/ApiAlarmServer'
import { request, handleParamsCase } from 'src/utils'
import _ from 'lodash'
import SelectInstance from 'src/components/SelectInstance'
import { isNumber } from 'lodash'

const initFormValues = {
  policyName: '',
  policyDesc: '',
  productType: undefined,
  trigger: 'rule',
  templateId: undefined,
  eventRules: [],
  resourceBindType: 3,
  projectId: undefined,
  instanceIds: [],
  urlNotice: [],
  userNotice: []
}

const EditEvent: FC<any> = ({ className }) => {
  const history = useHistory()
  const params = useParams()
  const loactionSearch = new URLSearchParams(history.location.search)
  const urlProductType = loactionSearch.get('productType')
  const formRef = useRef(null)
  const contactRef = useRef<any>()
  const callbackRef = useRef<any>()
  // 编辑策略详情id
  const urlPolicyName = _.get(params, 'policyName')
  // 表单
  const [formValues, setFormValues] = useState<any>({
    ...initFormValues,
    productType: urlProductType ? parseInt(urlProductType) : undefined
  })

  const { value: eventList } = useAsync(async () => {
    const result = await request(ApiEventCenter.getListSysEvents, {
      data: {
        ProductType: 999
      }
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      return result?.data.eventList
    } else {
      Message.error(result?.message)
      return []
    }
  }, [])

  useAsync(async () => {
    if (urlPolicyName) {
      // 获取事件详情
      const result = await request(API.GetEventPolicy, {
        data: {
          PolicyName: decodeURIComponent(urlPolicyName),
          ProductType: 999,
          PageIndex: 1,
          PageSize: 10
        }
      })
      const values = result?.data?.policyList?.[0]
      // 获取事件关联实例
      let instaces: any = null
      if (values?.instanceCount) {
        instaces = await request(ApiEventCenter.getPolictResource, {
          method: 'GET',
          data: {
            PolicyName: decodeURIComponent(urlPolicyName),
            pageIndex: 1
          }
        })
      }
      if (result && result?.code === 'Success' && values) {
        const {
          policyName,
          policyDesc,
          productType,
          templateId,
          eventRules,
          resourceBindType,
          projectId,
          urlNotice,
          userNotice,
          policyType,
          enabled
        } = values
        setFormValues({
          policyName,
          policyDesc,
          productType,
          trigger: templateId ? 'template' : 'rule',
          templateId: templateId || undefined,
          resourceBindType,
          eventRules,
          projectId,
          instanceIds: instaces?.data?.resourceList || [],
          urlNotice,
          userNotice,
          policyType,
          enabled
        })
      } else {
        Message.error(result?.message)
      }
      return {}
    }
  }, [urlPolicyName])

  const eventProductOpts = useMemo(() => {
    return eventList?.length ? eventListToOptions(eventList) || [] : []
  }, [eventList])

  // 是否支持项目组
  const projectFlag = useMemo(() => {
    if (formValues?.productType !== undefined && eventProductOpts?.length) {
      const iamProjectFlag = eventProductOpts.find(
        item => item.value === formValues?.productType
      )?.iamProjectFlag
      return iamProjectFlag === 1
    } else {
      return false
    }
  }, [eventProductOpts, formValues?.productType])

  // 修改formValues
  const changeFormValues = values => {
    setFormValues({
      ...formValues,
      ...values
    })
  }

  const eventOpts = useMemo(() => {
    if (eventList?.length && formValues.productType !== undefined) {
      return eventList.filter(({ productType }) => productType === formValues.productType)
    } else {
      return []
    }
  }, [eventList, formValues.productType])

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    if (validate) {
      const paramsForm: any = {}
      // 基础信息
      paramsForm.PolicyName = formValues.policyName
      paramsForm.PolicyDesc = formValues.policyDesc
      paramsForm.ProductType = formValues.productType
      paramsForm.ResourceBindType = formValues.resourceBindType
      paramsForm.InstanceIds = []
      paramsForm.PolicyType = formValues.resourceBindType === 2 ? 0 : formValues.policyType
      // 事件
      if (formValues.trigger === 'template') {
        paramsForm.TemplateId = formValues.templateId
        paramsForm.EventRules = []
      } else if (formValues.trigger === 'rule') {
        paramsForm.TemplateId = undefined
        paramsForm.EventRules = formValues.eventRules.map(rule => {
          delete rule.tagList
          delete rule.trigger
          return { ...handleParamsCase(rule) }
        })
      }
      const eventNameValid = paramsForm.EventRules.every(item => !!item.EventName)
      if (!paramsForm.TemplateId && (!eventNameValid || !paramsForm.EventRules?.length)) {
        Message.error('请选择事件')
        return
      }
      // 实例
      if (paramsForm.ResourceBindType === 3) {
        paramsForm.InstanceIds = formValues.instanceIds?.map(({ instanceId }) => instanceId) || []
      } else if (paramsForm.ResourceBindType === 2) {
        paramsForm.ProjectId = formValues.projectId
      }
      // 告警接收人
      const users = contactRef.current && contactRef.current.getRecivers()
      if (!users) return false
      paramsForm.UserNotice = users
      // 告警回调
      const callback = callbackRef.current && (await callbackRef.current.getUrl())
      if (!callback) return false
      paramsForm.UrlNotice = callback
      // 判断是修改还是创建
      const url = urlPolicyName
        ? ApiEventCenter.modifyEventPolicy
        : ApiEventCenter.createEventPolicy
      const result = await request(url, {
        method: 'POST',
        data: {
          ...paramsForm
        }
      })
      if (result?.code === 'Success') {
        Message.success(urlPolicyName ? '修改成功' : '创建成功')
        history.push('/monitor/alarmServer/rule/home?tab=event')
      } else {
        result?.message && Message.error(result?.message)
      }
    }
  }
  // 获取事件策略关联实例
  const getPolictResource = async () => {
    const result = await request(ApiEventCenter.getPolictResource, {
      method: 'GET',
      data: {
        PolicyName: decodeURIComponent(urlPolicyName),
        pageIndex: 1
      }
    })
    if (result && result?.code === 'Success' && result?.data.resourceList) {
      return result?.data.resourceList
    } else {
      return []
    }
  }

  return (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: _$('告警服务') },
          { title: _$('告警策略'), route: '/monitor/alarmServer/rule/home?tab=event' },
          { title: urlPolicyName ? decodeURIComponent(urlPolicyName) : _$('新建事件告警策略') }
        ]}
      />
      <Card className="event_card">
        <Form starOnRequired ref={formRef} labelWidth={100}>
          <h1 className="edit_event_title">{_$('基本信息')}</h1>
          <FormItem
            label={_$('策略名称')}
            value={formValues.policyName}
            rules={{ required: true }}
            messages={{ required: '请输入策略名称' }}
          >
            <Input
              value={formValues.policyName}
              disabled={!!urlPolicyName}
              placeholder="请输入策略名称"
              onChangeValue={value => {
                changeFormValues({
                  policyName: value
                })
              }}
            />
          </FormItem>
          <FormItem label={_$('描述')} value={formValues.policyDesc}>
            <Input
              value={formValues.policyDesc}
              placeholder="请输入描述"
              onChangeValue={value => {
                changeFormValues({
                  policyDesc: value
                })
              }}
            />
          </FormItem>
          <h1 className="edit_event_title">{_$('告警规则')}</h1>
          <FormItem
            label={_$('产品类型')}
            value={formValues.productType}
            rules={{ required: true }}
            messages={{ required: '请选择产品类型' }}
          >
            <Select
              value={formValues.productType}
              filterable
              placeholder={_$('请选择产品类型')}
              disabled={!!urlPolicyName}
              filterable
              onChangeValue={value => {
                changeFormValues({
                  productType: value,
                  templateId: undefined
                })
              }}
            >
              {eventProductOpts?.length &&
                eventProductOpts.map(({ label, value }) => (
                  <Option key={value} value={value}>
                    {_$(label)}
                  </Option>
                ))}
            </Select>
          </FormItem>
          {formValues.productType !== undefined ? (
            <>
              <FormItem
                label={_$('触发条件')}
                value={formValues.trigger}
                rules={{ required: true }}
                messages={{
                  required: _$('请选择触发条件')
                }}
              >
                <Radio
                  name="trigger"
                  trueValue="template"
                  value={formValues.trigger}
                  onChangeValue={(value: any) =>
                    changeFormValues({
                      trigger: value
                    })
                  }
                >
                  选择模版
                </Radio>
                <Radio
                  name="trigger"
                  trueValue="rule"
                  value={formValues.trigger}
                  onChangeValue={(value: any) =>
                    changeFormValues({
                      trigger: value
                    })
                  }
                >
                  手动匹配
                </Radio>
              </FormItem>
              {formValues.trigger === 'template' ? (
                <SelectTemplate
                  type="event"
                  value={formValues?.templateId}
                  productType={parseFloat(formValues.productType)}
                  onChange={value => {
                    changeFormValues({
                      templateId: value.TemplateID
                    })
                  }}
                />
              ) : null}
              {formValues.trigger === 'rule' ? (
                <FormItem
                  label={_$('事件名称')}
                  value={formValues.eventRules}
                  rules={{
                    required: true
                  }}
                  messages={{
                    required: _$('请选择事件名称')
                  }}
                >
                  <SelectEventRule
                    productType={parseFloat(formValues.productType)}
                    eventRules={formValues.eventRules}
                    eventList={eventOpts}
                    onChange={data => {
                      changeFormValues({
                        eventRules: data
                      })
                    }}
                  />
                </FormItem>
              ) : null}
              <FormItem
                label="关联实例"
                rules={{
                  required: true
                }}
                value={
                  isNumber(formValues.projectId) ? formValues.projectId : formValues.instanceIds
                }
              >
                <SelectInstance
                  productType={formValues.productType}
                  isRegionFilter={true}
                  defaultRadioValue={formValues.resourceBindType}
                  defaultInstance={formValues.instanceIds}
                  projectDimens={projectFlag}
                  // 127 = 已作废项目
                  disabled={
                    (!!urlPolicyName && formValues.resourceBindType === 2) ||
                    formValues.resourceBindType === 127
                  }
                  defalutProject={formValues.projectId}
                  projectDisabled={!!urlPolicyName}
                  allInstance={false}
                  instanceGroup={false}
                  getSelectedInstaces={
                    !!urlPolicyName && formValues.resourceBindType === 2
                      ? getPolictResource
                      : undefined
                  }
                  onChange={(radio, value) => {
                    if (radio === 1 || radio === 3) {
                      changeFormValues({
                        resourceBindType: radio,
                        instanceIds: value
                      })
                    } else if (radio === 2) {
                      changeFormValues({
                        resourceBindType: radio,
                        projectId: value
                      })
                    }
                  }}
                />
              </FormItem>
            </>
          ) : null}

          <div style={{ width: 800 }}>
            <FormItem label="告警联系人">
              <AlarmReciver ref={contactRef} defaultValue={formValues?.userNotice} />
            </FormItem>
            <FormItem slotLabel={<AlarmCallBackTooltip />}>
              <AlarmCallBack ref={callbackRef} defaultValue={formValues?.urlNotice} />
            </FormItem>
          </div>
          {formValues?.resourceBindType !== 2 ? (
            <>
              <h1 className="create_model_title">{_$('默认策略')}</h1>
              <div className="default-policy">
                <p>{_$('设置默认策略')}：</p>
                <Switch
                  disabled={urlPolicyName && formValues?.enabled !== 0}
                  on={_$('是')}
                  off={_$('非')}
                  width="80"
                  value={formValues.policyType === 1}
                  onChangeValue={v =>
                    setFormValues({
                      ...formValues,
                      policyType: v ? 1 : 0
                    })
                  }
                />
                <p className="tip">
                  每类产品下只允许有一项默认策略。若当前产品下已有默认策略，开启后，之前的默认策略会变为“非默认”状态
                </p>
              </div>
            </>
          ) : null}
        </Form>
        <div className="bottom_action">
          <Button
            onClick={() => {
              formSubmit()
            }}
            type="primary"
          >
            确认
          </Button>
          <Button
            onClick={() => {
              history.push('/monitor/alarmServer/rule/home?tab=event')
            }}
            type="default"
          >
            取消
          </Button>
        </div>
      </Card>
    </div>
  )
}

export default styled(EditEvent)`
  .event_card {
    position: relative;
    min-height: calc(100vh - 100px);
    padding-bottom: 64px;
    .k-form-label {
      margin-bottom: 0;
    }
    .edit_event_title {
      position: relative;
      font-size: 16px;
      vertical-align: middle;
      font-weight: 700;
      padding: 16px 0;
      &:first-child {
        padding-top: 0;
      }
    }
    .k-radio {
      margin-right: 16px;
      margin-bottom: 0;
    }
    .k-form-content {
      width: calc(100% - 100px);
    }
    .default-policy {
      display: flex;
      align-items: center;
      padding-top: 16px;
      p {
        margin: 0;
      }
      .tip {
        margin-left: 8px;
        color: #999;
      }
    }
    .bottom_action {
      display: flex;
      justify-content: flex-end;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 64px;
      padding: 16px 0;
      background: #ffffff;
      border-top: 1px solid #f0f0f0;
      padding-right: 16px;
      z-index: 1000;
      button {
        font-size: 14px;
        margin-left: 8px;
      }
    }
  }
`
